import { render, staticRenderFns } from "./FileSelectionModal.vue?vue&type=template&id=60b4d3c8&scoped=true"
import script from "./FileSelectionModal.vue?vue&type=script&lang=js"
export * from "./FileSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./FileSelectionModal.vue?vue&type=style&index=0&id=60b4d3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b4d3c8",
  null
  
)

export default component.exports